import { Coordinate, ProductOrientation } from '../types/productTypes'

export enum ImageRotation {
  None = 'None',
  QuarterTurnAnticlockwise = 'QuarterTurnAnticlockwise'
}

export interface ProductRenderSpec {
  skinImageRotation: ImageRotation
  slotPositions: readonly Coordinate[]
  imageScale: number
  skinImage: string
}

export function getProductImageRenderSpec(
  skinImage: string,
  imageScale: number | null,
  selectedProductOrientation: ProductOrientation,
  imageOrientation: ProductOrientation,
  defaultProductOrientation: ProductOrientation,
  slotPositions: readonly Coordinate[],
): ProductRenderSpec {
  const shouldRotateImage = imageOrientation !== selectedProductOrientation
  const rotatedButtons = defaultProductOrientation !== selectedProductOrientation

  // noinspection JSSuspiciousNameCombination
  const transformedSlotPositions = rotatedButtons ? slotPositions.map(
    ({ x, y }) => ({ x: y, y: x }),
  ) : slotPositions

  const effectiveImageScale = imageScale ?? 1

  return {
    skinImageRotation: shouldRotateImage ? ImageRotation.QuarterTurnAnticlockwise : ImageRotation.None,
    slotPositions: transformedSlotPositions,
    imageScale: effectiveImageScale,
    skinImage,
  }
}